import React from 'react';
import ActiveFilterItem from '../active-filter-item';
import ClearFiltersItem from '../clear-filters-item/clear-filters-item';
const FilterControllers = ({
  filter,
  onDeleteActiveFilter,
  onClearFilters,
  classNames = ''
}) => {
  const filterKeys = Object.keys(filter).sort(key => key === 'categoryId' ? -1 : 1);
  const getFilterItem = filterId => {
    const currentFilter = filter[filterId];
    if (currentFilter && Array.isArray(currentFilter)) {
      return currentFilter.map((item, index) => /*#__PURE__*/React.createElement(ActiveFilterItem, {
        key: item,
        itemName: item,
        onRequestDelete: () => onDeleteActiveFilter(filterId, index)
      }));
    }
    return /*#__PURE__*/React.createElement(ActiveFilterItem, {
      itemName: currentFilter,
      onRequestDelete: () => onDeleteActiveFilter(filterId)
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classNames
  }, filterKeys.map(filterId => getFilterItem(filterId)), /*#__PURE__*/React.createElement(ClearFiltersItem, {
    onClick: onClearFilters
  }));
};
export default FilterControllers;